// extracted by mini-css-extract-plugin
export default {"wrapper":"uLCxya7dDO","icon":"EX_GhRxbBN","title":"ehqpTIlyT7","description":"UZa5tuWM3x","dark":"dE8dQJDyqk"};